import { render, staticRenderFns } from "./teachingVideo.vue?vue&type=template&id=8568e0a2&scoped=true"
import script from "./teachingVideo.vue?vue&type=script&lang=js"
export * from "./teachingVideo.vue?vue&type=script&lang=js"
import style0 from "./teachingVideo.vue?vue&type=style&index=0&id=8568e0a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8568e0a2",
  null
  
)

export default component.exports